import React from 'react';
import { PaginationComponent, PreviewAltCard } from '../../../../components/Component';

const LeadsListPagination = ({
    itemPerPage,
    totalItems,
    paginate,
    currentPage,
    isLoading, // Added to prevent rendering pagination when table is loading
    dataLength // Added to check if there's data to paginate
}) => {
    if (isLoading) {
        return null; // Don't render pagination if the main table is loading
    }

    return (
        <PreviewAltCard>
            {dataLength > 0 ? (
                <PaginationComponent
                    itemPerPage={itemPerPage}
                    totalItems={totalItems}
                    paginate={paginate}
                    currentPage={currentPage}
                />
            ) : (
                <div className="text-center">
                    <span className="text-silent">
                        No items found.
                    </span>
                </div>
            )}
        </PreviewAltCard>
    );
};

export default LeadsListPagination;